import { ReactWrapper, UITable } from 'libraui-extension'
const manifest = {
  name: 'name',
  label: 'label',
  type: 'type',
  uiTable: UITable.BillItemBase,
  props: [
  ],
  children: []
}

export {
  ReactWrapper,
  manifest
}
